import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

import {finalize, map, takeUntil, tap} from 'rxjs/operators';

import {Destroyable} from '../../../destroyable.component';
import {FormDescriptorService} from '../../form-generator/form-descriptor.service';
import {SortUtilsService} from '../../sort/sort-utils.service';
import {EmpModelFamilyWithOptions} from '../hire.interface';

const hasOptions = (empModelFamilyWithOptions: EmpModelFamilyWithOptions) =>
  empModelFamilyWithOptions &&
  empModelFamilyWithOptions.options &&
  empModelFamilyWithOptions.options.length;

@Component({
  selector: 'gp-hire-employee-model',
  templateUrl: './hire-employee-model.component.html'
})
export class HireEmployeeModelComponent extends Destroyable implements OnInit, OnChanges {

  @Input()
  public cliRegId: number;

  @Input()
  public employeeModelForm: UntypedFormGroup;

  public modelsLoading: boolean = false;
  public empModelFamiliesWithOptions: Array<EmpModelFamilyWithOptions>;

  constructor(private formBuilder: UntypedFormBuilder,
              private formDescriptorService: FormDescriptorService,
              private sortUtilsService: SortUtilsService) {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges() {

    if (!this.cliRegId) {
      this.resetModels();
      return;
    }

    this.modelsLoading = true;
    this.formDescriptorService.getEmpModels(this.cliRegId)
      .pipe(
        tap((empModelFamiliesWithOptions: Array<EmpModelFamilyWithOptions>) => this.sortUtilsService.sortByTransId(empModelFamiliesWithOptions, 'familyTransId')),
        map((empModelFamiliesWithOptions: Array<EmpModelFamilyWithOptions>) => this.sortEmpModelsAndAddFormControl(empModelFamiliesWithOptions)),
        takeUntil(this.componentDestroyed$),
        finalize(() => this.modelsLoading = false))
      .subscribe((empModelFamiliesWithOptions: Array<EmpModelFamilyWithOptions>) => {
        this.empModelFamiliesWithOptions = empModelFamiliesWithOptions;
      });
  }

  private resetModels(): void {
    this.empModelFamiliesWithOptions = null;
  }

  private sortEmpModelsAndAddFormControl(empModelFamiliesWithOptions: Array<EmpModelFamilyWithOptions>): Array<EmpModelFamilyWithOptions> {
    return empModelFamiliesWithOptions
      .filter(hasOptions)
      .map((empModelFamilyWithOptions: EmpModelFamilyWithOptions) => {
        this.employeeModelForm.addControl(empModelFamilyWithOptions.familyName,
          this.formBuilder.control(undefined, empModelFamilyWithOptions.isRequired ? Validators.required : null));

        this.sortUtilsService.sortByTransId(empModelFamilyWithOptions.options, 'transId');

        empModelFamilyWithOptions.options.forEach(empModelOption => {
          empModelOption.familyTransId = empModelFamilyWithOptions.familyTransId;
        });

        return empModelFamilyWithOptions;
      });
  }

}
